import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IWorkExperience } from 'app/shared/model/work-experience.model';
import { getEntity, updateEntity, createEntity, reset } from './work-experience.reducer';

export const WorkExperienceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const workExperienceEntity = useAppSelector(state => state.workExperience.entity);
  const loading = useAppSelector(state => state.workExperience.loading);
  const updating = useAppSelector(state => state.workExperience.updating);
  const updateSuccess = useAppSelector(state => state.workExperience.updateSuccess);

  const handleClose = () => {
    navigate('/work-experience' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...workExperienceEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...workExperienceEntity,
          user: workExperienceEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.workExperience.home.createOrEditLabel" data-cy="WorkExperienceCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.workExperience.home.createOrEditLabel">Create or edit a WorkExperience</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="work-experience-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.workExperience.position')}
                id="work-experience-position"
                name="position"
                data-cy="position"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.employerName')}
                id="work-experience-employerName"
                name="employerName"
                data-cy="employerName"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.employmentType')}
                id="work-experience-employmentType"
                name="employmentType"
                data-cy="employmentType"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.startDate')}
                id="work-experience-startDate"
                name="startDate"
                data-cy="startDate"
                type="date"
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.endDate')}
                id="work-experience-endDate"
                name="endDate"
                data-cy="endDate"
                type="date"
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.isPresentJob')}
                id="work-experience-isPresentJob"
                name="isPresentJob"
                data-cy="isPresentJob"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fivePlusApp.workExperience.employeeLogo')}
                id="work-experience-employeeLogo"
                name="employeeLogo"
                data-cy="employeeLogo"
                type="text"
              />
              <ValidatedField
                id="work-experience-user"
                name="user"
                data-cy="user"
                label={translate('fivePlusApp.workExperience.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/work-experience" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WorkExperienceUpdate;
